const WA = (msg: string) => `https://wa.me/33604417682?text=${encodeURIComponent(msg)}`

export default function Footer() {
  return (
    <footer className="mt-16 py-10 text-center" style={{ background: '#1A3C6E', color: 'white' }}>
      <p className="font-bold text-base">© Loris Hug Innovation</p>
      <p className="opacity-70 text-sm mt-1">Outil sur invitation — Tous droits réservés</p>
      <p className="text-xs opacity-50 mt-2">Suivi mensuel · Charte tarifaire · Gestion produits · Badge temps</p>
      <a href={WA('Bonjour Loris, je souhaite accéder à la version complète de l\'outil Pilotage Salon.')}
        target="_blank" rel="noopener noreferrer"
        className="inline-block mt-5 px-6 py-3 rounded-xl font-semibold text-sm transition-all hover:opacity-90"
        style={{ background: 'white', color: '#1A3C6E' }}>
        Demander la version complète →
      </a>
    </footer>
  )
}
